import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './LoadMore.scss';

const LoadMore = (props) => {
  if (window.innerWidth < 700 && props.contactedCount >= 2) {
    return (
      <div className={styles.loadmoreContainerOnMobile}>
        <div className={styles.overlay}>
          {/* <span> */}
          {/* Click below button to load more colleges! */}
          {/* </span><br /> */}
          <button onClick={() => props.loadmoreColleges()}>LOAD MORE COLLEGES</button>
        </div>

      </div>
    );
  } else if (window.innerWidth >= 700 && props.contactedCount >= 5) {
    return (
      <div className={cn('col s12', styles.desktopLoadMoreContainer)}>
        <span>Click below button to add more colleges!</span><br />
        <button onClick={() => props.loadmoreColleges()}>LOAD MORE</button>
      </div>
    );
  }
  return null;
};

LoadMore.propTypes = {
  contactedCount: PropTypes.number,
  loadmoreColleges: PropTypes.func,
};

LoadMore.defaultProps = {
  contactedCount: 0,
  loadmoreColleges: () => {},
};

export default LoadMore;



// WEBPACK FOOTER //
// ./src/components/DashboardView/LoadMore/Loadmore.js